import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import forms from 'modules/surveys/store/collections/forms'
import groups from 'modules/surveys/store/collections/groups'
import questionCategories from 'modules/surveys/store/collections/questionCategories'
import questionConfigs from 'modules/surveys/store/collections/questionConfigs'
import type Form from 'modules/surveys/store/models/Form'
import type Group from 'modules/surveys/store/models/Group'
import type QuestionCategory from 'modules/surveys/store/models/QuestionCategory'
import type QuestionConfig from 'modules/surveys/store/models/QuestionConfig'

class QuestionGroupConfig extends Model {
  constructor(attr = {}) {
    super(attr)
    makeObservable(this, {
      questionConfigs: computed,
      questionConfigsWithoutCategory: computed,
      questionCategories: computed,
      respondent: computed,
      target: computed,
      form: computed,
    })
  }

  static urlRoot() {
    return '/surveys/question_group_configs'
  }

  get indexes() {
    return ['target_id', 'respondent_id', 'surveys_form_id']
  }

  get questionConfigs(): QuestionConfig[] {
    return questionConfigs.filter({
      surveys_question_group_config_id: this.attributes.id,
    })
  }

  get questionConfigsWithoutCategory(): QuestionConfig[] {
    return questionConfigs.filter({
      surveys_question_group_config_id: this.attributes.id,
      surveys_question_category_id: null,
    })
  }

  get questionCategories(): QuestionCategory[] {
    return questionCategories.filter({
      surveys_question_group_config_id: this.attributes.id,
    })
  }

  get respondent(): Group | null | undefined {
    return groups.find({
      id: this.attributes.respondent_id,
    })
  }

  get target(): Group | null | undefined {
    return groups.find({
      id: this.attributes.target_id,
    })
  }

  get form(): Form | null | undefined {
    return forms.find({
      id: this.attributes.surveys_form_id,
    })
  }
}

export default QuestionGroupConfig
